import { useEffect, useState } from 'react';
import { api, formatApiError } from '@/lib/api';

export const money = (value) => value == null ? 'To be quoted' : new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 2 }).format(value);
export const phaseLabel = (phase) => ({ single: 'Single phase', three: 'Three phase', unsure: 'Supply unconfirmed' }[phase] || 'Choose supply');

export function useSystemCatalogue() {
  const [catalogue, setCatalogue] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    api.get('/system-builder/catalogue', { signal: controller.signal }).then(({ data }) => setCatalogue(data)).catch((e) => { if (!controller.signal.aborted) setError(formatApiError(e, 'Catalogue could not load. Please try again.')); });
    return () => controller.abort();
  }, [retry]);
  return { catalogue, error, retry: () => setRetry((value) => value + 1) };
}

export function useSystemEvaluation(selection) {
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const key = selection ? JSON.stringify(selection) : '';
  useEffect(() => {
    setSnapshot(null); setError(''); setBusy(false);
    if (!key) return;
    const controller = new AbortController();
    setBusy(true);
    api.post('/system-builder/evaluate', { selection: JSON.parse(key) }, { signal: controller.signal }).then(({ data }) => { setSnapshot(data); setBusy(false); }).catch((e) => { if (!controller.signal.aborted) { setError(formatApiError(e, 'Could not check this configuration.')); setBusy(false); } });
    return () => controller.abort();
  }, [key, attempt]);
  return { snapshot, error, busy, retry: () => setAttempt((value) => value + 1) };
}

export const CatalogueState = ({ error, retry }) => <div className="system-empty" role={error ? 'alert' : 'status'} data-testid="catalogue-state"><p>{error || 'Loading the verified catalogue…'}</p>{error && <button className="system-button" onClick={retry} data-testid="catalogue-retry">Try again</button>}</div>;
